let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kS1Zx")).then(() => parcelRequire('dvfbF'));